export enum EQuestName {
  BUILD_TEAM = 'BUILD_TEAM',
  DAILY_CLAIM_REWARD = 'DAILY_CLAIM_REWARD',
  DAILY_PLAY_GAME = 'DAILY_PLAY_GAME',
  INVITE_A_FRIEND = 'INVITE_A_FRIEND',
  PLAY_WITH_FRIEND = 'PLAY_WITH_FRIEND',
  POKER_ENTHUSIAST = 'POKER_ENTHUSIAST',
  SUBSCRIBE_TELEGRAM_CHANNEL = 'SUBSCRIBE_TELEGRAM_CHANNEL',
}
